import React from 'lib/react';
import {
  EVAlert, EVGrid, EVTypography, makeStyles, EVTooltip,
} from 'lib/components';

const useStyles = makeStyles((theme) => ({
  alert: {
    backgroundColor: theme.evPalette.mango[100],
  },
  heading: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.evPalette.charcoal[900],
  },
  tooltip: {
    background: theme.evPalette.charcoal[800],
    fontSize: '14px',
    borderRadius: '4px',
    alignItems: 'center',
    padding: '15px',
  },
  arrow: {
    color: theme.evPalette.charcoal[800],
  },
}));

export default function PropertyDataDisclaimer() {
  const classes = useStyles();
  return (
    <EVTooltip
      arrow
      interactive
      classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
      // eslint-disable-next-line max-len
      title="This report was generated using automated machine learning and computer vision algorithms applied to aerial imagery and is provided for informational purposes only. This report is intended to supplement, not replace, professional judgment and on-site verification by qualified experts. The analysis may contain errors, omissions, or inaccuracies and should be verified by qualified professionals before use in any decision-making. Eagle View Technologies, Inc., along with its subsidiaries and affiliates, disclaims all warranties and, (to the fullest extent permitted by applicable law),  all liability for any damages arising from or in connection with the use of the report. By accessing and using this report, you acknowledge that you have read, understood, and agree to be bound by the terms of this disclaimer."
    >
      <EVAlert className={classes.alert} severity="warning">
        <EVGrid container direction="column">
          <EVTypography className={classes.heading}>
            AI-POWERED ANALYSIS DISCLAIMER
          </EVTypography>
        </EVGrid>
      </EVAlert>
    </EVTooltip>
  );
}

// heading="AI-POWERED ANALYSIS DISCLAIMER"
// eslint-disable-next-line max-len
// body="This report was generated using automated machine learning and computer vision algorithms applied to aerial imagery and is provided for informational purposes only. This report is intended to supplement, not replace, professional judgment and on-site verification by qualified experts. The analysis may contain errors, omissions, or inaccuracies and should be verified by qualified professionals before use in any decision-making. Eagle View Technologies, Inc., along with its subsidiaries and affiliates, disclaims all warranties and, (to the fullest extent permitted by applicable law),  all liability for any damages arising from or in connection with the use of the report. By accessing and using this report, you acknowledge that you have read, understood, and agree to be bound by the terms of this disclaimer."
